import {h, Fragment} from "preact"
import Product from './Product'
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default () => {
    const { response: { products }, loading } = useAppState()

    useEffect(() => {
        if(!window.StampedFn?.reloadUGC) return;
        window.StampedFn.reloadUGC();
    }, [])

    return (
        <product-list class="product-facet__product-list product-list" style={loading ? 'opacity: 0.3;' : ''}>
            <div class="product-list__inner">
                {products.hits.map((hit, index) => (
                    <Product 
                        product={hit}
                        key={hit.productId || index}
                    />
                ))}
            </div>
        </product-list>
    )
}
